import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';
import { isImpersonating } from '../supportMode/supportModeSession';
import { rememberPostLoginReturnTo } from '../brandSupportDeepLink';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isLoggedIn() || isImpersonating();

  if (!isAuthenticated) {
    // Preserve in-app deep links (e.g. Support email → exact Case) across login.
    rememberPostLoginReturnTo(location);
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
